export default __webpack_public_path__ + "static/media/Leggings of Insanity.c6b68524.jpg";